import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Manufacturer } from 'src/app/models/manufacturer.model';
import { Model } from 'src/app/models/model.model';
import { Type } from 'src/app/models/type.interface';
import { ManufacturersService } from 'src/app/services/manufacturers/manufacturers.service';
import { ModelsService } from 'src/app/services/models/models.service';

@Component({
  selector: 'app-edit-model',
  templateUrl: './edit-model.component.html',
  styleUrls: ['./edit-model.component.css'],
})
export class EditModelComponent {
  modelDetails: Model = new Model();
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modelService: ModelsService,
    private manufacturersService: ManufacturersService,
    private toastr: ToastrService
  ) {}

  manufacturers: Manufacturer[] = [];
  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];
  dateNow: Date = new Date();
  ManufacturerIdError: boolean = false;
  TypeError: boolean = false;

  public types: Array<Type> = [
    { Id: 1, TypeName: 'SWRO' },
    { Id: 2, TypeName: 'BWRO' },
  ];
  ngOnInit(): void {
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if (
      loggedInuserRole.role == 'Standard User' ||
      loggedInuserRole.role == 'Internal User' ||
      loggedInuserRole.role == 'Regional User'
    ) {
      this.logout();
    }
    this.route.paramMap.subscribe({
      next: (params) => {
        const id = atob(params.get('id')!);
        if (id) {
          this.modelService.getModel(id).subscribe({
            next: (response) => {
            
              this.modelDetails = response;
              console.log(this.modelDetails);
            },
          });
        }
      },
    });

    this.manufacturersService.getAllManufacturers().subscribe({
      next: (manufacturers) => {
        this.manufacturers = manufacturers;
       
      },
      error: (response) => {
        console.log(response);
      },
    });
  }

  validation() {
    let isValid = true;

    if (this.modelDetails.ManufacturerId == null) {
      this.ManufacturerIdError = true;
      isValid = false;
    } else {
      this.ManufacturerIdError = false;
    }

    if (this.modelDetails.Type == null) {
      this.TypeError = true;
      isValid = false;
    } else {
      this.TypeError = false;
    }

    return isValid;
  }

  updateModel() {
    const dateNowISO = this.dateNow.toISOString();
    this.modelDetails.UpdatedAt = dateNowISO;
    this.modelDetails.IsActive = 1;

    if (this.validation()) {
      this.modelService
        .updateModel(this.modelDetails.Id, this.modelDetails)
        .subscribe({
          next: (response) => {
            this.toastr.success(
              'Element Model Edited Successfully.',
              'Information'
            );
            this.router.navigate(['/models']);
          },
        });
    } else {
      this.toastr.error('Please validate all fields', 'Error');
    }
  }

  deleteModel(id: number) {
    this.modelService.deleteModel(id).subscribe({
      next: (response) => {
        this.toastr.error('Element Model Deleted Successfully.', 'Information');
        this.router.navigate(['/models']);
      },
    });
  }
  logout() {
    sessionStorage.clear();
    this.router.navigate(['login']);
  }
}
